import React from "react";
import { ReactComponent as ErrorIcon } from "../../../img/trade-interface/error-inline.svg";
import { Spacer } from "../../../components/general/Spacer/Spacer";
import { UI_ERROR_MESSAGES } from "../../../config/errorCodes";

export interface ErrorSectionProps {
  error: string | undefined;
}

export const ErrorSection: React.FC<ErrorSectionProps> = props => {
  return (
    <>
      <div
        className="inline-error d-flex align-items-start error-information my-3"
        data-testid="error-section"
        style={{ fontSize: "14px", padding: "10px" }}
      >
        <div style={{ width: "20px", height: "20px" }}>
          <ErrorIcon width={20} height={20} strokeWidth={1.5} />
        </div>
        <Spacer width="10px" />
        {props.error ? props.error : UI_ERROR_MESSAGES.A}
      </div>
    </>
  );
};
